import React from 'react'
import { useNavigate } from 'react-router-dom'

export interface PlaceAddButtonProps {
  storeId?: string | number
  onClick?: () => void
  buttonSize?: number
  className?: string
  isAdded?: boolean
}

const PlaceAddButton: React.FC<PlaceAddButtonProps> = ({
  storeId,
  onClick,
  buttonSize = 26,
  className = '',
  isAdded = false,
}) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else if (storeId !== undefined) {
      navigate(`/store-review/${storeId}`)
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`
        flex
        items-center
        justify-center
        ${className}
      `}
      style={{ width: buttonSize, height: buttonSize }}
    >
      <img
        src={
          isAdded
            ? '/images/checkbox-bold-filled.png'
            : '/images/bold-plus-icon.png'
        }
        alt={isAdded ? '기록 완료' : '추가'}
        className="w-full h-full"
      />
    </button>
  )
}

export default PlaceAddButton
